export var VideoSourceTypes;
(function (VideoSourceTypes) {
    VideoSourceTypes["user"] = "user";
    VideoSourceTypes["youtube"] = "youtube";
    VideoSourceTypes["vimeo"] = "vimeo";
})(VideoSourceTypes || (VideoSourceTypes = {}));
//https://d1sonmy4sf0d9y.cloudfront.net/images/104201-796a85d3327d47268b9cc0c87f9d7583/img_385_200.jpg
//https://d1sonmy4sf0d9y.cloudfront.net/images/104201-796a85d3327d47268b9cc0c87f9d7583/info.json
// {"id": 355228, "file_id": 2323416, "url": "//d1sonmy4sf0d9y.cloudfront.net/images/104201-796a85d3327d47268b9cc0c87f9d7583", "analysis_url": "//s3-eu-west-1.amazonaws.com/wizcontent/images/104201-796a85d3327d47268b9cc0c87f9d7583/imageanalysis.json", "progress_url": "https://d1sonmy4sf0d9y.cloudfront.net/job/ea901448-3e43-4ae7-8645-b21117ea0a6f/status.json"}
//https://my.zap.works/zapcode/8850091406817944442/tracking-image/info/
export class ZMLImage {
    imagesById = {
        '0': {
            title: 'image 1',
            imageUrl: 'https://d1sonmy4sf0d9y.cloudfront.net/images/4-c738383881ef454fad6d0ab791ddb4f3/img_512_512',
            aspectRatio: 1.33,
        },
        '1': {
            title: 'image 2',
            imageUrl: 'https://d1sonmy4sf0d9y.cloudfront.net/images/104201-8a7e6c87e2a24bd6b3c6d7da382c706d/img_512_512',
            aspectRatio: 1.6,
        },
    };
    getTitle = (id) => this.imagesById[id].title;
    getAspectRatio = (id) => this.imagesById[id].aspectRatio;
    getImageUrl = (id) => this.imagesById[id].imageUrl;
}
export class ZMLTrackingImage {
    trackingImagesById = {
        '0': {
            imageUrl: 'https://d1sonmy4sf0d9y.cloudfront.net/images/104201-796a85d3327d47268b9cc0c87f9d7583/img_512_512',
            aspectRatio: 1.6,
        },
    };
    getAspectRatio = (id) => this.trackingImagesById[id].aspectRatio;
    getImageUrl = (id) => this.trackingImagesById[id].imageUrl;
}
export class ZMLVideo {
    videosById = {
        '0': {
            title: 'video 1',
            videoUrl: 'https://d1sonmy4sf0d9y.cloudfront.net/videos/170258-da97c0f7b14f45288486e00cb83d7c61/auto.m3u8',
            playOnStart: false,
            thumbnailUrl: 'https://d1sonmy4sf0d9y.cloudfront.net/videos/170258-da97c0f7b14f45288486e00cb83d7c61/img_512_512',
            aspectRatio: 1.5660377358490567,
            source: VideoSourceTypes.user,
        },
    };
    getTitle = (id) => this.videosById[id].title;
    getAspectRatio = (id) => this.videosById[id].aspectRatio;
    getVideoUrl = (id) => this.videosById[id].videoUrl;
    getPlayOnStart = (id) => this.videosById[id].playOnStart;
    getThumbnailUrl = (id) => this.videosById[id].thumbnailUrl;
    getSource = (id) => this.videosById[id].source;
}
export class ZMLExternalVideo {
    videosById = {
        '1': {
            title: 'video 2',
            description: 'Description 2',
            externalId: 'U5IailIzqdc',
            playOnStart: false,
            thumbnailUrl: 'https://d1sonmy4sf0d9y.cloudfront.net/images/170258-f387dc793b2640bd97b0039f8da34270/img_512_512',
            aspectRatio: 1.77,
            duration: 0,
            source: VideoSourceTypes.youtube,
        },
        '2': {
            title: 'video 3',
            description: 'Description 2',
            externalId: '253989945',
            playOnStart: false,
            thumbnailUrl: 'https://d1sonmy4sf0d9y.cloudfront.net/images/170258-6578491afd71486481497ad0bbad0a76/img_512_512',
            aspectRatio: 1.77,
            duration: 0,
            source: VideoSourceTypes.vimeo,
        },
    };
    getTitle = (id) => this.videosById[id].title;
    getAspectRatio = (id) => this.videosById[id].aspectRatio;
    getPlayOnStart = (id) => this.videosById[id].playOnStart;
    getDescription = (id) => this.videosById[id].description;
    getDuration = (id) => this.videosById[id].duration;
    getExternalId = (id) => this.videosById[id].externalId;
    getThumbnailUrl = (id) => this.videosById[id].thumbnailUrl;
    getSource = (id) => this.videosById[id].source;
}
// export class Video implements ZML.Video {
// 	private _imagesById: ZmlData = {
// 		'1':
// 			'https://d1sonmy4sf0d9y.cloudfront.net/images/4-c738383881ef454fad6d0ab791ddb4f3',
// 		'2':
// 			'https://d1sonmy4sf0d9y.cloudfront.net/images/104201-b1e3a9e0976a4602bf2ffc913b794da2',
// 	};
// 	private _videosById: ZmlData = {
// 		'1':
// 			'https://d1sonmy4sf0d9y.cloudfront.net/videos/170258-da97c0f7b14f45288486e00cb83d7c61',
// 		'2':
// 			'https://d1sonmy4sf0d9y.cloudfront.net/images/170258-f387dc793b2640bd97b0039f8da34270',
// 		'3':
// 			'https://d1sonmy4sf0d9y.cloudfront.net/images/170258-6578491afd71486481497ad0bbad0a76',
// 	};
// 	public getImageUrl(id: string) {
// 		return `${this._imagesById[id]}/img_512_512`;
// 	}
// 	public getImageInfoUrl(id: string) {
// 		return `${this._imagesById[id]}/info.json`;
// 	}
// 	public getVideoUrl(id: string) {
// 		switch (id) {
// 			case '1':
// 				return `${this._videosById[id]}/auto.m3u8`;
// 			case '2':
// 				return 'https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=qw9hwa_-raA';
// 			case '3':
// 				return 'https://player.vimeo.com/video/253989945';
// 			default:
// 				break;
// 		}
// 	}
// 	public getVideoInfoUrl(id: string) {
// 		return `${this._videosById[id]}/info.json`;
// 	}
// 	public getThumbnailUrl(id: string) {
// 		return `${this._videosById[id]}/img_512_512`;
// 	}
// }
